<template>
  <aside class="WizardSidebar">
    <img v-if="imageSrc" :src="imageSrc" class="image">
    <div class="text">
      <h3 class="title">{{ content.title }}</h3>
      <p v-for="textChunk, index in textChunks"
        :key="index"
        v-html="textChunk"
        class="textChunk"
      ></p>
    </div>
  </aside>
</template>

<script>
import inseegoConnectPng from '../assets/sidebar/inseego-connect.png'
import networkIconPng from '../assets/sidebar/network-icon.png'
import teamMemberDirkPng from '../assets/sidebar/team-member-dirk.png'
import teamMemberMattPng from '../assets/sidebar/team-member-matt.png'
import usaBadgesPng from '../assets/sidebar/usa-badges.png'
import usaMapPng from '../assets/sidebar/usa-map.png'

const images = {
  inseegoConnectPng,
  networkIconPng,
  teamMemberDirkPng,
  teamMemberMattPng,
  usaBadgesPng,
  usaMapPng,
}

export default {
  props: {
    content: Object,
  },
  computed: {
    imageSrc() {
      if (this.content.image) {
        return images[this.content.image]?.src
      }
    },
    textChunks() {
      return this.content.text.map(
        (pText) => (
          pText.replaceAll(/{([^}]*)./g, (_, str) => `<strong>${str}</strong>`)
        )
      )
    }
  },
}
</script>

<style scoped>

.image {
  max-height: 70px;
}

.text {
  max-width: 18em;
}

.image + .text {
  margin-top: var(--spacing-6);
}

.title {
  font-size: var(--font-size-1);
  font-weight: 600;
  line-height: 1.2;
  color: var(--brand-color);
}

.textChunk {
  font-size: var(--font-size-2);
  font-weight: 400;
  line-height: 1.3;
  color: var(--text-black);
}

.textChunk + .textChunk {
  margin-top: var(--spacing-3);
}

@media (--screen-lg) {

  .image {
    max-height: 140px;
  }
}
</style>
